import { render, staticRenderFns } from "./ShoopingCartButton.vue?vue&type=template&id=375e8ba4&scoped=true"
import script from "./ShoopingCartButton.vue?vue&type=script&lang=js"
export * from "./ShoopingCartButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375e8ba4",
  null
  
)

export default component.exports